import { Payment } from '@linktivity/link-payment';
import config from '../config';

const accountApi = new Payment.AccountApi(config);

export default accountApi;
